import Vue from 'vue';
import API from "../api/service";
import router from '../routes';
import {EventBus} from "../event-bus";

export const client = {
    state: {
        jwt: JSON.parse(localStorage.getItem('jwt')),
        license_plate: JSON.parse(localStorage.getItem('license_plate')),
        workroom: JSON.parse(localStorage.getItem('workroom')),
        make_id: JSON.parse(localStorage.getItem('make_id')),
        maintenance_included: JSON.parse(localStorage.getItem('maintenance_included')),
        repl_car_entitlement_code: JSON.parse(localStorage.getItem('repl_car_entitlement_code')),
        client_current_location: '',
        client_personal_data: JSON.parse(localStorage.getItem('client_personal_data')),
    },

    actions: {
        setJwt(context, payload) {
            return context.commit('setJwt', payload);
        },

        setLicensePlate(context, payload) {
            return context.commit('setLicensePlate', payload);
        },

        setWorkroom(context, payload) {
            return context.commit('setWorkroom', payload);
        },

        setMakeId(context, payload) {
            return context.commit('setMakeId', payload);
        },

        setMaintenanceIncluded(context, payload) {
            return context.commit('setMaintenanceIncluded', payload);
        },

        setReplCarEntitlementCode(context, payload) {
            return context.commit('setReplCarEntitlementCode', payload);
        },

        setClientPersonalData(context, payload) {
            return context.commit('setClientPersonalData', payload);
        },

        clearJwt(context) {
            return context.commit('setJwt', null);
        },

        clearLicensePlate(context) {
            return context.commit('setLicensePlate', null);
        },

        clearWorkroom(context) {
            return context.commit('setWorkroom', null);
        },

        clearMakeId(context) {
            return context.commit('setMakeId', null);
        },

        clearMaintenanceIncluded(context) {
            return context.commit('setMaintenanceIncluded', null);
        },

        clearReplCarEntitlementCode(context) {
            return context.commit('setReplCarEntitlementCode', null);
        },

        logoutClient(context) {
            /*
            return context.dispatch('setJwt').then(() => {}, () => {}).finally(() => {
                return context.commit('setLicensePlate', null);
            });
            */

            return context.dispatch('setJwt').then(() => {
                return context.dispatch('setWorkroom').then(() => {
                    return context.commit('setMaintenanceIncluded', null).then(() => {
                        return context.commit('setReplCarEntitlementCode', null).then(() => {
                            return context.commit('setMakeId', null).then(() => {}, () => {}).finally(() => {
                                return context.commit('setLicensePlate', null);
                            });
                        }, () => {});
                    }, () => {});
                }, () => {});
            }, () => {});
        },

        refreshJwt(context, customJwt = null) {
            return new Promise((resolve, reject) => {
                if (!customJwt && !context.state.jwt) {
                    resolve();
                }

                API.postAuthorize(context.state.license_plate)
                    .then((response) => {
                        if (response.status === 200) {
                            return resolve(context.commit('setJwt', response.data.jwt));
                        }
                    })
                    .catch((error) => {
                        return reject(
                            context.dispatch('logoutClient').then(() => {}, () => {}).finally(() => {
                                localStorage.clear();

                                context.commit('setDistanceFilter', 10);
                                context.commit('setClientCurrentLocation', '');
                                context.commit('setServices', []);
                                context.commit('setLicensePlate', null);

                                router.replace({name: 'login'});

                                window.location.reload();
                            })
                        );
                    });
            });
        },
    },

    mutations: {
        setJwt(state, payload) {
            if (payload) {
                localStorage.setItem('jwt', JSON.stringify(payload));
            }

            Vue.set(state, 'jwt', payload);
        },

        setLicensePlate(state, payload) {
            if (payload) {
                localStorage.setItem('license_plate', JSON.stringify(payload));
            }

            Vue.set(state, 'license_plate', payload);
        },

        setWorkroom(state, payload) {
            if (payload) {
                localStorage.setItem('workroom', JSON.stringify(payload));
            }

            Vue.set(state, 'workroom', payload);
        },

        setMakeId(state, payload) {
            if (payload) {
                localStorage.setItem('make_id', JSON.stringify(payload));
            }

            Vue.set(state, 'make_id', payload);
        },

        setMaintenanceIncluded(state, payload) {
            localStorage.setItem('maintenance_included', JSON.stringify(payload));

            Vue.set(state, 'maintenance_included', payload);
        },

        setReplCarEntitlementCode(state, payload) {
            localStorage.setItem('repl_car_entitlement_code', JSON.stringify(payload));

            Vue.set(state, 'repl_car_entitlement_code', payload);
        },

        setClientCurrentLocation(state, { location }) {
            state.client_current_location = location;
        },

        setClientPersonalData(state, payload) {
            if (payload) {
                localStorage.setItem('client_personal_data', JSON.stringify(payload));
            }

            Vue.set(state, 'client_personal_data', payload);
        },
    },

    getters: {
        getJwt(state) {
            return state.jwt;
        },

        getLicensePlate(state) {
            return state.license_plate;
        },

        getWorkroom(state) {
            return state.workroom;
        },

        getMakeId(state) {
            return state.make_id;
        },

        getMaintenanceIncluded(state) {
            return state.maintenance_included;
        },

        getReplCarEntitlementCode(state) {
            return state.repl_car_entitlement_code;
        },

        getClientLocation(state) {
            return state.client_current_location;
        },

        getClientPersonalData(state) {
            return state.client_personal_data;
        },
    }
}
